<template>
  <div class="top-padding ticket-top-padding">
    <div class="page-top">
      <div class="page-top-inner-wrap">
        <h2 class="page-title" tabindex="0">이용권</h2>
        <p class="page-text">LIVE, VOD는 물론 이제 영화까지 wavve 이용권으로 더 넓은 콘텐츠 세상으로의 항해, wavve와 함께하세요!</p>
      </div>
    </div>

    <div class="ticket-wrap">
      <div class="ticket-body">
        <voucher-menu v-if="$route.name !== 'voucher_promotion'"/>
        <div class="voucher-wrap">
          <router-view name="voucherContent" :key="$route.name" ></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VoucherMenu from '@/components/voucher/VoucherMenu'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { scrollTop } from '@/common/utils/common'
import { SET_CURRENT_MENU } from '@/common/resources/const'
import { mapMutations } from 'vuex'

export default {
  components: {
    VoucherMenu
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU])
  },
  mounted () {
    this[SET_CURRENT_MENU]('voucher')
  },
  created () {
    scrollTop()
    if (cookie.isWavveOn()) {
      cookie.removeItems({ keyList: ['pzInfo', 'cs', 'pz'] })
      cookie.setItem('pz', JSON.stringify({ isPooqzone: false }), false, constant.URL_COOKIE_DOMAIN, '/')
      window.location.reload()
    }
  }
}
</script>
<style lang="css" src="@/assets/css/ticket.css"></style>
